import { getGridNumericOperators } from '@mui/x-data-grid-pro';

import { getFilteredOperators } from '../get-filtered-operators';

// Must match: https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/colDef/gridNumericOperators.ts
export enum GridNumericOperator {
  EqualTo = '=',
  NotEqualTo = '!=',
  GreaterThan = '>',
  GreaterThanEqualTo = '>=',
  LessThan = '<',
  LessThanEqualTo = '<=',
  isEmpty = 'isEmpty',
  isNotEmpty = 'isNotEmpty',
  isAnyOf = 'isAnyOf',
  isBetween = 'isBetween',
}

export const getFilteredGridNumericOperators = (
  allowedOperators: GridNumericOperator[],
) => getFilteredOperators(getGridNumericOperators(), allowedOperators);
